import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Catalog from './pages/Catalog';
import Requests from './pages/Requests';
import Profile from './pages/Profile';
import Subscription from './pages/Subscription';

type Tab = 'catalog' | 'requests' | 'subscription' | 'profile';

export default function App() {
  const [user, setUser] = useState<any>(null);
  const [installPrompt, setInstallPrompt] = useState<any>(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      setInstallPrompt(e);
    });
    window.addEventListener('appinstalled', () => {
      setInstallPrompt(null);
      setIsInstalled(true);
    });
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
    }
  }, []);

  const handleInstall = async () => {
    if (installPrompt) {
      installPrompt.prompt();
      const { outcome } = await installPrompt.userChoice;
      if (outcome === 'accepted') setIsInstalled(true);
      setInstallPrompt(null);
      return;
    }
    // Si no hay prompt (iOS Safari o ya instalada), mostrar instrucciones
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isIOS || isSafari) {
      alert('Para instalar en iOS:\n1. Toca el botón Compartir (□↑)\n2. Selecciona "Añadir a pantalla de inicio"');
    } else {
      alert('Para instalar:\n1. Busca el ícono de instalación (⊕) en la barra de direcciones del navegador\n2. O usa el menú del navegador → "Instalar app"');
    }
  };
  const [tenant, setTenant] = useState<any>(null);
  const [tab, setTab] = useState<Tab>('catalog');

  useEffect(() => {
    const u = localStorage.getItem('customer_user');
    const t = localStorage.getItem('customer_tenant');
    if (u) setUser(JSON.parse(u));
    if (t) {
      const parsed = JSON.parse(t);
      setTenant(parsed);
      // Actualizar manifest con datos del tenant
      const manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
      if (manifestLink && parsed.slug) {
        manifestLink.href = `/api/customer/manifest?slug=${parsed.slug}`;
      }
      // Actualizar theme-color
      const meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement;
      if (meta && parsed.color) meta.content = parsed.color;
      // Actualizar título
      if (parsed.name) document.title = parsed.name;
    }
  }, []);

  const handleLogin = (u: any, t: any) => { setUser(u); setTenant(t); };
  const handleLogout = () => {
    localStorage.removeItem('customer_token');
    localStorage.removeItem('customer_user');
    setUser(null); setTenant(null);
  };

  if (!user) return <Login onLogin={handleLogin} />;

  const color = tenant?.color || '#7C3AED';

  const tabs: { key: Tab; icon: string; label: string }[] = [
    { key: 'catalog',      icon: '🎵', label: 'Catálogo' },
    { key: 'requests',     icon: '📩', label: 'Peticiones' },
    { key: 'subscription', icon: '💳', label: 'Plan' },
    { key: 'profile',      icon: '👤', label: 'Perfil' },
  ];

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', position: 'relative', minHeight: '100vh', background: '#0f0f1a' }}>
      {/* Contenido */}
      <div style={{ paddingBottom: '70px' }}>
        {tab === 'catalog'      && <Catalog />}
        {tab === 'requests'     && <Requests />}
        {tab === 'subscription' && <Subscription />}
        {tab === 'profile'      && <Profile onLogout={handleLogout} />}
      </div>

      {/* Banner instalación PWA */}
      {/* Bottom nav */}
      <div style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: '900px', background: '#1a1a2e', borderTop: '1px solid #2a2a3e', display: 'flex', zIndex: 100 }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{ flex: 1, padding: '0.75rem 0.5rem', background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
            <span style={{ fontSize: '1.3rem' }}>{t.icon}</span>
            <span style={{ fontSize: '0.65rem', color: tab === t.key ? color : '#666', fontFamily: 'sans-serif', fontWeight: tab === t.key ? 600 : 400 }}>{t.label}</span>
          </button>
        ))}
        {!isInstalled && (
          <button onClick={handleInstall} style={{ flex: 1, padding: '0.75rem 0.5rem', background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
            <span style={{ fontSize: '1.3rem' }}>📲</span>
            <span style={{ fontSize: '0.65rem', color: '#a78bfa', fontFamily: 'sans-serif', fontWeight: 600 }}>Instalar</span>
          </button>
        )}
      </div>
    </div>
  );
}
